// import {MyCartQty} from "@/api/merchant/cart"
import router, {resetRouter} from "@/router"
import {FormatToken} from "@/utils/index.js"
import {MessageBox, Message} from "element-ui"

import {
	login,
	logout,
	getInfo,
	loginPwd,
	loginCode,
	loginScan
} from "@/api/user"
import {getToken, setToken, removeToken} from "@/utils/auth"

import Cookies from "js-cookie"

const state = {
	token: getToken(),
	name: Cookies.get("name"),
	info: Cookies.get("info") || "",
	avatar: "",
	introduction: "",
	roles: [],
	// menus:Cookies.get('menus'),
	menus: localStorage.getItem("menus")
	// cartNum: 0
}

const mutations = {
	SET_TOKEN: (state, token) => {
		state.token = token
	},
	SET_INTRODUCTION: (state, introduction) => {
		state.introduction = introduction
	},
	SET_NAME: (state, name) => {
		state.name = name
	},
	SET_AVATAR: (state, avatar) => {
		state.avatar = avatar
	},
	SET_ROLES: (state, roles) => {
		state.roles = roles
	},
	SET_MENU: (state, menus) => {
		state.menus = menus
	},
	SET_INFO: (state, info) => {
		state.info = info
	}
	// ADD_PART: (state, num) => {
	// 	state.cartNum += num
	// },
	// SET_CART_Num: (state, num) => {
	// 	state.cartNum = num
	// }
}

const actions = {
	saveUserInfo({commit}, userInfo) {
		const {token, info} = userInfo
		console.log(token, info)
		commit("SET_TOKEN", token)
		setToken(token)
		if (info.Name != null) {
			commit("SET_NAME", info.Name)
			Cookies.set("name", info.Name)
		} else {
			commit("SET_NAME", "暂未填写用户名")
			Cookies.set("name", "暂未填写用户名")
		}

		commit("SET_INFO", JSON.stringify(info))
		Cookies.set("info", info)
		// return new Promise((resolve, reject) => {
		// 	console.log(resolve, userInfo)
		// })
	},
	// user login
	login({commit}, userInfo) {
		return new Promise((resolve, reject) => {
			loginPwd(userInfo)
				.then(({token, info}) => {
					commit("SET_TOKEN", token)
					setToken(token)
					if (info.Name != null) {
						commit("SET_NAME", info.Name)
						Cookies.set("name", info.Name)
					} else {
						commit("SET_NAME", "暂未填写用户名")
						Cookies.set("name", "暂未填写用户名")
					}

					commit("SET_INFO", JSON.stringify(info))
					Cookies.set("info", info)
					// let token1 = getToken()
					// let b = FormatToken(token1)
					// console.log(JSON.parse(b),"请求头token");
					resolve()
				})
				.catch((error) => {
					console.log(error)
					reject(error)
				})
		})
	},
	loginByScan({commit}, userInfo) {
		return new Promise((resolve, reject) => {
			loginScan(userInfo)
				.then(({token, info}) => {
					if (token) {
						commit("SET_TOKEN", token)
						setToken(token)
						if (info.Name != null) {
							commit("SET_NAME", info.Name)
							Cookies.set("name", info.Name)
						} else {
							commit("SET_NAME", "暂未填写用户名")
							Cookies.set("name", "暂未填写用户名")
						}
						commit("SET_INFO", JSON.stringify(info))
						Cookies.set("info", info)
					} else {
					}
					resolve()
				})
				.catch((error) => {
					Message.closeAll()
					reject(error)
				})
		})
	},
	loginByCode({commit}, userInfo) {
		console.log(userInfo)
		return new Promise((resolve, reject) => {
			loginCode(userInfo)
				.then(({token, info}) => {
					console.log(info)
					commit("SET_TOKEN", token)
					setToken(token)
					if (info.Name != null) {
						commit("SET_NAME", info.Name)
						Cookies.set("name", info.Name)
					} else {
						commit("SET_NAME", "暂未填写用户名")
						Cookies.set("name", "暂未填写用户名")
					}
					commit("SET_INFO", JSON.stringify(info))
					Cookies.set("info", info)
					resolve()
				})
				.catch((error) => {
					reject(error)
				})
		})
	},

	// get user info
	getInfo({commit, state}) {
		return new Promise((resolve, reject) => {
			// commit("SET_ROLES", [state.name]);
			// resolve(generateRoute(JSON.parse(state.menus)))
			commit("SET_ROLES", "admin")
			// commit("SET_NAME", "你的名字")
			resolve({roles: "admin"})
			// getInfo(state.token).then(response => {
			//   const { data } = response

			//   if (!data) {
			//     reject('Verification failed, please Login again.')
			//   }

			//   const { roles, name, avatar, introduction } = data

			//   // roles must be a non-empty array
			//   if (!roles || roles.length <= 0) {
			//     reject('getInfo: roles must be a non-null array!')
			//   }

			//   commit('SET_ROLES', roles)
			//   commit('SET_NAME', name)
			//   commit('SET_AVATAR', avatar)
			//   commit('SET_INTRODUCTION', introduction)
			//   resolve(data)
			// }).catch(error => {
			//   reject(error)
			// })
		})
	},

	logout({commit, state, dispatch}) {
		return new Promise((resolve, reject) => {
			commit("SET_TOKEN", "")
			commit("SET_NAME", "")
			// commit("SET_ROLES", [])
			removeToken()
			Cookies.remove("name")
			commit("SET_INFO", "")
			Cookies.remove("info")
			resetRouter()
			resolve()

			// dispatch("resetToken")

			// logout(state.token).then(() => {
			//   commit('SET_TOKEN', '')
			//   commit('SET_ROLES', [])
			//   removeToken()
			//   resetRouter()
			//   resolve()
			// }).catch(error => {
			//   reject(error)
			// })
		})
	},

	// remove token
	resetToken({commit}) {
		return new Promise((resolve) => {
			commit("SET_TOKEN", "")
			commit("SET_NAME", "")
			// commit("SET_ROLES", [])
			removeToken()
			Cookies.remove("name")
			resetRouter()
			resolve()
		})
	},

	// dynamically modify permissions
	async changeRoles({commit, dispatch}, role) {
		const token = role + "-token"

		commit("SET_TOKEN", token)
		setToken(token)

		const {roles} = await dispatch("getInfo")

		resetRouter()

		// generate accessible routes map based on roles
		const accessRoutes = await dispatch("permission/generateRoutes", roles, {
			root: true
		})
		// dynamically add accessible routes
		router.addRoutes(accessRoutes)

		// reset visited views and cached views
		dispatch("tagsView/delAllViews", null, {root: true})
	}
	// addToCart({commit, state}, param = {num: 1}) {
	// 	const {num} = param
	// 	return new Promise((resolve) => {
	// 		setTimeout(() => {
	// 			commit("ADD_PART", num)
	// 			resolve()
	// 		}, 200)
	// 	})
	// },
	// async getCartNum({commit}) {
	// 	return new Promise((resolve) => {
	// 		MyCartQty().then((num) => {
	// 			commit("SET_CART_Num", num)
	// 			resolve(num)
	// 		})
	// 		//   setTimeout(() => {
	// 		//     let num = 6;
	// 		//     commit("SET_CART_Num", num);
	// 		//     resolve(num);
	// 		//   }, 200);
	// 	})
	// }
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}
